// ** Initial State
const initialState = {
  new_notification_count: 0,
  new_notifications: [],
  old_notifications: [],
  update: null,
  updated_fields_list: null,
  notificationsWithPagination: {
    limit: 30,
    page: 0,
    total_pages: null,
    total_records: null,
    data: null,
  },
  pageLoader: true,
};

const notifications = (state = initialState, action) => {
  switch (action.type) {
    case "GET_NOTIFICATION_DROPDOWN":
      return {
        ...state,
        new_notification_count: action.data.new_notification_count,
        new_notifications: action.data.new_notifications,
        old_notifications: action.data.old_notifications,
      };
    case "UPDATE_NOTIFICATION_VIEWED":
      return {
        ...state,
        update: action.data,
      };
    case "UPDATED_FIELDS_LIST":
      return {
        ...state,
        updated_fields_list: action.data,
      };
    case "GET_ALL_NOTIFICATIONS_WITH_PAGINATION":
      return {
        ...state,
        notificationsWithPagination: action.data,
        pageLoader: false,
      };
    case "PAGE_LOADER":
      return { ...state, pageLoader: action.data };
    default:
      return { ...state };
  }
};
export default notifications;
